export default {
      id: "minus-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#minus",
      toString: function () {
        return this.url;
      }
    }